/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Button, Chip, Paper, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PageHeaderManage from '../PageHeader/PageHeaderManage';
import { t } from 'i18next';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { addManageRefrsh, updateManageByIdRefresh } from '../../actions/mangeAction';
import { resetError, resetSelectedUser, resetState } from '../../slices/manageSlice';
import { showErrorToast, showSuccessToast } from '../../slices/toastSlice';
import Loader from '../Loader';

const AddNameAndEmail = () => {

    const location = useLocation();
    const state = location.state;
    const { id, item, mode } = state || {};
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const { updated, added, hasError, errorMessage, loading } = useSelector((state) => state.manage) || {};
    const parentId = searchParams.get('parentId');
    const navigation = useNavigate();

    const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);


    const validationSchema = yup.object().shape({
        name: yup.string().required('Name is required'),
        email: yup.string().required('Email is required')
            .email('Invalid email'),
                ccEmail: yup
                        .string()
                        .nullable()
                        .test(
                            "multi-emails",
                            "One or more CC emails are invalid",
                            (value) => {
                                if (!value) return true; 
            
                                const emails = value
                                    .split(",")
                                    .map(e => e.trim())
                                    .filter(e => e !== "");
            
                                if (emails.length === 0) return true;
            
                                return emails.every(e => isEmail(e));
                            }
                        ),
        
        webUrl: mode.toLowerCase() === 'shippingline' ? yup.string().url('Invalid URL').required('Web URL is required') : yup.string().notRequired(),


    });

    const formik = useFormik({
        initialValues: {
            name: item?.name || '',
            email: item?.email || null,
            ccEmail: item?.ccEmail || "",
            webUrl: item?.webUrl || null,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => handleSaveUpdate(values),
        enableReinitialize: true,
    });
    const handleSaveUpdate = (data) => {


        const payload = data

        if (id) {
            dispatch(updateManageByIdRefresh({ mode: mode, id, data: payload }));
            return;
        }
        dispatch(addManageRefrsh({ mode: mode, data: payload, parentId }));

    }

    useEffect(() => {
        return () => {
            dispatch(resetState());
            dispatch(resetError());

        };
    }, []);

    useEffect(() => {


        if ((updated || added) && !hasError) {

            if (added) {

                dispatch(showSuccessToast(`The ${mode.toLowerCase()} ${formik.values.name} has been saved successfully`));
            }
            if (updated) {
                dispatch(showSuccessToast(`The ${mode.toLowerCase()} ${item.name} has been updated successfully`));
            }

            navigation(`/${mode}/${parentId ? 'list' : 'view'}` + location.search, {
                state: {
                    showSuccess: true
                }
            });
        }

        if (hasError) {
            dispatch(showErrorToast(`Error: ${errorMessage}`));
            dispatch(resetError());
        }


    }, [updated, added, hasError]);




    const handleKeyDown = (event, submitForm) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            //submitForm();
        }
    };


    if (loading === 'pending') {
        return (
            <Loader />
        )
    }


     const normalizedCcEmails = Array.isArray(formik.values.ccEmail)
        ? formik.values.ccEmail
        : typeof formik.values.ccEmail === "string"
            ? String(formik.values.ccEmail).split(/[;,]+/).map((s) => s.trim()).filter(Boolean)
            : [];


    return (
        <>

                <Paper variant='p1'>
                    <PageHeaderManage title={t('ConsigneeDock').toUpperCase()} />

                    <Box display='grid' gridTemplateColumns={`${!id ? "repeat(2, 1fr)" : "repeat(2, 1fr)"}`} gap={"20px"} >

                        <TextField
                            label="Name"
                            variant="outlined"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                        />

                        <TextField
                            label="Email"
                            name="email"
                            variant="outlined"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />


                        <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            value={normalizedCcEmails}
                            onChange={(event, newValue) => {

                                if (Array.isArray(newValue)) {
                                    const joined = newValue.map(e => String(e).trim()).filter(Boolean).join(",");
                                    formik.setFieldValue("ccEmail", joined);
                                } else {
                                    formik.setFieldValue("ccEmail", "");
                                }

                            }}
                            renderTags={(value, getTagProps) =>
                                Array.isArray(value)
                                    ? value.map((option, index) => (
                                        <Chip
                                            variant="outlined"
                                            label={option}
                                            {...getTagProps({ index })}
                                            key={option + index}
                                        />
                                    ))
                                    : null
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("CC Email(s)")}
                                    placeholder={t("Type an email and press Enter")}
                                    error={formik.touched.ccEmail && Boolean(formik.errors.ccEmail)}
                                    helperText={
                                        (formik.touched.ccEmail && formik.errors.ccEmail) ||
                                        t("Enter multiple emails; press Enter to add each")
                                    }
                                    onBlur={() => formik.setFieldTouched("ccEmail", true)}
                                    fullWidth
                                />
                            )}
                        />

                        {mode.toLowerCase() === 'shippingline' &&
                            <TextField
                                label="Web URL"
                                name="webUrl"
                                variant="outlined"
                                type="url"
                                placeholder="example.com or https://example.com"
                                value={formik.values.webUrl}
                                onChange={formik.handleChange}
                                onBlur={(e) => {
                                    const raw = (e.target.value || '').trim();
                                    // if user entered something without protocol, add https:// by default
                                    if (raw && !/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(raw)) {
                                        formik.setFieldValue('webUrl', `https://${raw}`);
                                    }
                                    formik.handleBlur(e);
                                }}
                                error={formik.touched.webUrl && Boolean(formik.errors.webUrl)}
                                helperText={(formik.touched.webUrl && formik.errors.webUrl) || t('If no protocol provided, https:// will be added automatically')}
                            />
                        }


                    </Box>
                    <Box display='grid' gridTemplateColumns={"repeat(4, 1fr)"} marginY={"40px"} gap={"20px"} >



                        <Box display='grid' gridTemplateColumns={"repeat(2, 1fr)"} alignItems='center'>
                            <Button variant="b2" sx={{
                                marginInline: '20px'
                            }} onClick={() => {
                                navigate(`/${mode}/view?` + searchParams.toString());
                                dispatch(resetSelectedUser())
                            }} >Cancel</Button>

                            <Button variant="b1" onClick={formik.handleSubmit}>Save</Button>

                        </Box>
                    </Box>

                </Paper>

        </>
    )
}

export default AddNameAndEmail